import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <Section background="light" className="text-center" data-id="element-168">
      <div className="max-w-3xl mx-auto" data-id="element-169">
        <h2 className="text-3xl md:text-5xl font-bold text-brand-black mb-6" data-id="element-170">
          Ready to Get <span className="text-brand-red" data-id="element-171">Protected?</span>
        </h2>
        <p className="text-gray-600 text-lg mb-10" data-id="element-172">
          Join thousands of satisfied clients who trust us with their insurance
          needs.
        </p>

        <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" onSubmit={e => e.preventDefault()} data-id="element-173">
          <input type="email" placeholder="Enter your email address" className="flex-1 px-6 py-4 rounded-full bg-white border border-gray-300 text-brand-black placeholder:text-gray-400 focus:outline-none focus:border-brand-red focus:ring-1 focus:ring-brand-red transition-all" data-id="element-174" />
          <Button size="lg" className="whitespace-nowrap" data-id="element-175">
            Get Started <ArrowRight className="ml-2 h-5 w-5" data-id="element-176" />
          </Button>
        </form>
        <p className="text-gray-500 text-sm mt-6" data-id="element-177">
          Free consultation and quote. NAICOM-certified insurance brokerage.
        </p>
      </div>
    </Section>;
}